export default __webpack_public_path__ + "static/media/Red_sphere.29fbd08b.svg";